'use strict';
salesTaxDueController.$inject = ['$scope', '$q', '$interval', 'reportHelper', 'accountStructureService', 'BUSY_MESSAGE'];
angular.module('schoolLinqApp').controller('salesTaxDueController', salesTaxDueController);

function salesTaxDueController($scope, $q, $interval, reportHelper, accountStructureService, BUSY_MESSAGE) {
	var viewModel = getViewModel();
	$scope.vm = viewModel;

	$scope.reportInterval = null;
	$scope.isReportFinished = false;

	$scope.vm.busyPromise = $q.all([$scope.vm.loadAccountStructures($scope.vm)]);

	function getViewModel() {
		var model = {
			report: {
				fromDT: null,
				toDT: null,
				sortBy: 'Vendor',
				sortElement: '',
				includeNoTaxDue: false,
				separateFoodTaxes: false,
			},
			elements: [],
			busyMessage: BUSY_MESSAGE.Loading,
			busyPromise: null,
			validationErrors: [],
			errors: null,
		};

		function validateReportParams(model) {
			model.validationErrors = [];
			let isValid = true;

			if (model.report.fromDT > model.report.toDT) {
				model.validationErrors.push('From Date cannot be after the To Date.');
				isValid = false;
			}

			return isValid;
		}

		function openReport(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingReport;
			model.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				SortBy: model.report.sortBy,
				SortElement: model.report.sortElement,
				IncludeNoTaxDue: model.report.includeNoTaxDue,
				SeparateFoodTaxes: model.report.separateFoodTaxes,
			};

			reportHelper.getReport($scope, '/api/fundreports/salestaxduereport', report, 'SalesTaxDueReport.pdf');
		}

		function exportExcel(model) {
			$scope.reportForm.$setSubmitted();
			if (!$scope.reportForm.$valid) return false;

			if (!validateReportParams(model)) return false;

			$scope.isReportFinished = false;
			model.busyMessage = BUSY_MESSAGE.GeneratingExcelFile;
			model.busyPromise = $scope.reportInterval = $interval(function () {
				if ($scope.isReportFinished) {
					$interval.cancel($scope.reportInterval);
					$scope.isReportFinished = false;
				}
			}, 1000);

			var report = {
				FromDT: model.report.fromDT,
				ToDT: model.report.toDT,
				SortBy: model.report.sortBy,
				SortElement: model.report.sortElement,
				SeparateFoodTaxes: model.report.separateFoodTaxes,
			};

			reportHelper.getExcel($scope, '/api/fundreports/salestaxdueexcel', report, 'SalesTaxDue.xlsx');
		}

		function loadAccountStructures(model) {
			return accountStructureService.getStructure().then(finishLoadingAccountStructures);

			function finishLoadingAccountStructures(response) {
				if (response.data.accountStructure.UnifiedElementMap !== null) {
					model.elements = response.data.accountStructure.UnifiedElementMap.split('.');
					// remove the Fund element
					model.elements.splice(response.data.accountStructure.UnifiedElementFundIndex, 1);
				} else {
					let assetElements = response.data.accountStructure.AssetElementMap.split('.');
					assetElements.splice(response.data.accountStructure.AssetElementFundIndex, 1);
					let liabilityElements = response.data.accountStructure.LiabilityElementMap.split('.');
					liabilityElements.splice(response.data.accountStructure.LiabilityElementFundIndex, 1);
					let reserveElements = response.data.accountStructure.ReserveElementMap.split('.');
					reserveElements.splice(response.data.accountStructure.ReserveElementFundIndex, 1);
					let revenueElements = response.data.accountStructure.RevenueElementMap.split('.');
					revenueElements.splice(response.data.accountStructure.RevenueElementFundIndex, 1);
					let expenseElements = response.data.accountStructure.ExpenseElementMap.split('.');
					expenseElements.splice(response.data.accountStructure.ExpenseElementFundIndex, 1);

					model.elements = _.union(assetElements, liabilityElements, reserveElements, revenueElements, expenseElements);
				}

				return angular.noop;
			}
		}

		return angular.extend(model, {
			loadAccountStructures: _.partial(loadAccountStructures, model),
			openReport: _.partial(openReport, model),
			exportExcel: _.partial(exportExcel, model),
		});
	}
}
